// extracted by mini-css-extract-plugin
export default {"container":"About_container__5yiMg","closeIcon":"About_closeIcon__-MTqu","logo":"About_logo__vPZw-","title":"About_title__MyZaK","version":"About_version__MOBeR"};